import client from 'app/client';

export interface PersonneMoraleAdresseDto {
  line1?: string;
  line2?: string;
  line3?: string;
  zipCode?: string;
  city?: string;
  country?: string;
}

export interface PersonneMoraleCollaboratorPreviewDto {
  accessId: string;
  abpUserId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  isPrincipal: boolean;
  isActive: boolean;
  lastConnectionDate?: string | null;
}

export interface PersonneMoraleListItemDto {
  id: string;
  designation: string;
  numeroSiret?: string;
  capital: number;
  rcsVille?: string;
  rcsNumero?: string;
  orias?: string;
  isOriasSociety: boolean;
  isValidOrias?: boolean | null;
  rcp?: string;
  telephone?: string;
  courtierId?: string | null;
  /** Nature acteur (CRT, CIE, GST, MIA, PIM) — null pour une PM cliente. */
  nature?: string | null;
  natureLibelle?: string | null;
  /** Sous-nature (variant, ex. 'GRO' = courtier grossiste), null sinon. */
  sousNature?: string | null;
  sousNatureLibelle?: string | null;
  raisonJuridique?: { id: string; libelle?: string } | null;
  adresse?: PersonneMoraleAdresseDto | null;
  collaborators: PersonneMoraleCollaboratorPreviewDto[];
  collaboratorsCount: number;
  // Champs présents uniquement sur le GET détail (entité complète ReadPersonneMoraleDto).
  /** Enum back CanalAcquisition, sérialisée en nombre (0/absent = non renseigné). */
  canalAcquisition?: number | null;
  lastControlOrias?: string | null;
  commentaire?: string | null;
}

export interface SearchPersonnesMoralesResponse {
  items: PersonneMoraleListItemDto[];
  totalCount: number;
}

export interface SearchPersonnesMoralesCommand {
  searchString?: string;
  pageNumber: number;
  pageSize: number;
  /** Code nature (ex. CIE) — liste restreinte à cette nature de PM. */
  nature?: string;
}

export async function searchPersonnesMorales(
  command: SearchPersonnesMoralesCommand
): Promise<SearchPersonnesMoralesResponse> {
  const { data } = await client.post<SearchPersonnesMoralesResponse>(
    '/backoffice/personnes-morales/liste',
    command
  );
  return data;
}

// --- Legacy GET pour la vue détail (récupère l'entité complète ReadPersonneMoraleDto) ---

export async function getPersonneMorale(
  personneMoraleId: string
): Promise<PersonneMoraleListItemDto> {
  const { data } = await client.get<PersonneMoraleListItemDto>(
    `/backoffice/acteurs/personne-morale/${personneMoraleId}`
  );
  return data;
}
